export function joinWithOr(arr?: string[], lastSeparator = 'or') {
  const sanitizedArray = arr.filter((a) => !!a)
  if (sanitizedArray.length <= 2) {
    return sanitizedArray.join(` ${lastSeparator} `)
  }
  return sanitizedArray.slice(0, -1).join(', ') + `, ${lastSeparator} ` + sanitizedArray.slice(-1)
}
